// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchCategoriesByIdsParams = {
    authToken: string,
    categoryIds: number[],
    deployment: string,
};

export const fetchCategoriesByIds = ({ authToken, categoryIds, deployment }: FetchCategoriesByIdsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<CATEGORY-API>/getcategorydescription' });
        request.send({ categoryIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
